export const SITE = {
  name: "Anappuram Wooden Furniture Work",
  since: 1990,
  yearsLabel: "35+",
  address: "Kinassery, Palakkad, Kerala",
  phone: "+91 94472 97179",
  phoneLink: "tel:+919447297179",
  whatsapp: "+91 87145 14035",
  whatsappLink: "https://wa.me/918714514035",
  email: null, // add once the client confirms one
  hours: "Mon – Sat: 9:00 AM – 7:00 PM", // confirm with client
  reach: "Orders taken from all over India",
};